import {
  SELECTED_INTERVENTION,
  ADD_STIMULATION_TO_CART,
  DELETE_INTERVENTION_TO_CART,
  DELETE_STIMULATION_TO_CART,
  RESET_TO_CART,
  SELECT_DENSITY_LOSS,
  SELECTED_FILTERAI,
  SELECTED_FILTERRI,
  SELECTED_FILTERDENSITY,
  SELECTED_FILTERINTERNAL,
  RESET_TO_INITIAL,
  SELECTED_FILTERHEIGHT,
  RESET_FILTERHEIGHT,
  SELECTED_HEIGHT_FILTEROVERVIEW,
  SELECTED_DENSITY_FILTEROVERVIEW,
  SELECTED_POWERBI,
  SET_SELECTED_COUNTRY,
  SET_INTERVENTION_SOURCE 
} from "./actionTypes"

const INIT_STATE = {
  globalCountrySelected : "",
  interventionSource: "", 
  intervention: [],
  stimulation: [],
  filterListData: {
    country: "",
    wasteLevel1: "All",
    wasteLevel2: "All",
    area: "All",
    businessGroup: "All",
    interventionBucket: "All",
    simulation: "All",
  },
  filterListRI: {
    country: "",
    wasteLevel1: "All",
    wasteLevel2: "All",
    area: "All",
    businessGroup: "All",
    interventionBucket: "All",
    simulation: "All",
    registeredBy: "All",
  },
  overviewDensityFilters: {
    country: "",
    specialPack:"Including",
    launchPack:["All"],
    businessGroup: "BEAUTY & WELLBEING",
    TargetDensity: "Top Performers (Country)",
    riskFactor2Y: 25,
    riskSavingfactor: 25,
    primaryRisk: 75,
    palletRisk: 25,
    maxPalletWeight_single: 2205.0,
    maxPalletWeight_double: 2205.0,
    maxPFSpertruckPrimary: 30,
    maxPFSpertruckSecondary: 30,
    maxWeightpertruckPrimary: 45000,
    maxWeightpertruckSecondary: 45000,
    // Added by Kartick on 9th May for Indonesia market
    maxPalletWeight: 1000.17,
    emptyPalletWeight: 1000.17,
    oneyMaxCapacityPerTruck: 1000.17,
    oneyMaxPFSPerTruck: 1000.17,
    oneYSuDCSavings: 25,
    oneYInterDCSavings: 25,
    palletMgtService: 25,
    storageSavings: 25,
    handlingInSavings: 25,
    handingOutSavings: 25,
    twoSavings: 25,
  },
  overviewHeightFilters: {
    country: "",
    businessGroup: "BEAUTY & WELLBEING",
    maxPFSpertruckPrimary: 30,
    maxPFSpertruckSecondary: 30,
    maxWeightpertruckPrimary: 45000,
    maxWeightpertruckSecondary: 45000,
    DC:[],
    ToMonth:'',
    FromMonth:'',
  },

  densityFilter: {
    country: "",
    // businessGroup: state.intervention[0].bg,
    businessGroup: "BEAUTY & WELLBEING",
    Category: "",
    format: [],
    PackType: [],
    PackSize: [],
    specialPack:"",
    launchPack:"",
    TargetDensity: "Top Performers (Country)",
    DC:[],
    ToMonth:'',
    FromMonth:'',
    riskFactor2Y: 25,
    riskSavingfactor: 25,
    primaryRisk: 75,
    palletRisk: 25,
    maxPalletWeight: 0,
    maxPalletWeight_single: 0,
    maxPalletWeight_double: 0,
    maxPFSpertruckPrimary: 30,
    maxPFSpertruckSecondary: 30,
    maxWeightpertruckPrimary: 45000,
    maxWeightpertruckSecondary: 45000,
  },

  internalFilter: {
    country: "",
    businessGroup: "BEAUTY & WELLBEING",
    Category: "",
    format: "",
    brand:"",
    PackType: "",
    specialPack:"",
    launchPack:"",
    savings: 4000,
  },
  heightFilter: {
    country: "",
    businessGroup: "BEAUTY & WELLBEING",
    category: "",
    brand: "",
    format: "",
    sizePackForm: "",
    specialPack: "",
    launchPack:"",
    DC:[],
    ToMonth:'',
    FromMonth:'',
  },
  selectedPowerBI: {
    key: "",
    title: "",
    icon: "",
    name: "",
    path: "",
    reportType: "",
  },
  densityLoss: [],
  error: {},
}

const InterventionDetails = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECTED_INTERVENTION:
      return {
        ...state,
        intervention: [action.payload],
      }
    
    case SET_SELECTED_COUNTRY:
        return {
          ...state,
          globalCountrySelected: action.payload,
          filterListData: {
            ...state.filterListData,
            country: action.payload,
          },
          filterListRI: {
            ...state.filterListRI,
            country: action.payload,
          },
          densityFilter: {
            ...state.densityFilter,
            country: action.payload,
          },
          internalFilter: {
            ...state.internalFilter,
            country: action.payload,
          },
          heightFilter: {
            ...state.heightFilter,
            country: action.payload,
          },
          overviewDensityFilters: {
            ...state.overviewDensityFilters,
            country: action.payload,
          },
          overviewHeightFilters: {
            ...state.overviewHeightFilters,
            country: action.payload,
          },
        };
    
    case SET_INTERVENTION_SOURCE:
          return {
            ...state,
            interventionSource: action.payload,
          }

    case SELECTED_FILTERAI:
      return {
        ...state,
        filterListData: action.payload,
      }
    case SELECTED_FILTERRI:
      return {
        ...state,
        filterListRI: action.payload,
      }
      case SELECTED_FILTERDENSITY:
        return {
          ...state,
          densityFilter: action.payload,
        }
    case SELECTED_DENSITY_FILTEROVERVIEW:
      return {
        ...state,
        overviewDensityFilters: action.payload,
      }
    case SELECTED_HEIGHT_FILTEROVERVIEW:
      return {
        ...state,
        overviewHeightFilters: action.payload,
      }
    case SELECTED_POWERBI:
      return {
        ...state,
        selectedPowerBI: action.payload,
      }
      case SELECTED_FILTERINTERNAL:
        return {
          ...state,
          internalFilter:{
            ...state.internalFilter,
            ...action.payload,
          } 
         
        }
    case SELECTED_FILTERHEIGHT:
      return {
        ...state,
        heightFilter: action.payload,
      }
    case RESET_FILTERHEIGHT:
      return {
        ...state,
        heightFilter: {
          country: "",
          businessGroup: "",
          category: "",
          brand: "",
          format: "",
          sizePackForm: "",
          specialPack: "",
          launchPack:""
        },
      }
    case SELECT_DENSITY_LOSS:
      return {
        ...state,
        densityLoss: [action.payload],
      }
    case ADD_STIMULATION_TO_CART:
      return {
        ...state,
        stimulation: [...state.stimulation, action.payload],
      }

    case DELETE_INTERVENTION_TO_CART:
      return {
        ...state,
        datacart: action.payload,
      }
    case DELETE_STIMULATION_TO_CART:
      return {
        ...state,
        stimulation: action.payload,
      }

    case RESET_TO_INITIAL:
      return {
        ...state,
        intervention: [],
        stimulation: [],
        filterListData: {
          country: "",
          wasteLevel1: "",
          wasteLevel2: "",
          area: "",
          businessGroup: "",
          interventionBucket: "",
          simulation: "",
        },
        filterListRI: {
          country: "",
          wasteLevel1: "",
          wasteLevel2: "",
          area: "",
          businessGroup: "",
          interventionBucket: "",
          simulation: "",
          registeredBy: "",
        },
        densityFilter: {
          country: "",
          // businessGroup: state.intervention[0].bg,
          businessGroup: "",
          Category: "",
          format: [],
          PackType: [],
          PackSize: [],
          specialPack:"",
          launchPack:"",
          TargetDensity: "Top Performers (Country)",
          riskFactor2Y: 20,
          riskSavingfactor: 20,
          maxPalletWeight_single: 2205.0,
          maxPalletWeight_double: 2205.0,
          maxPFSpertruckPrimary: 30,
          maxPFSpertruckSecondary: 30,
          maxWeightpertruckPrimary: 45000,
          maxWeightpertruckSecondary: 45000,
        },
        overviewHeightFilters: {
          country: "",
          businessGroup: "",
        },
        overviewDensityFilters: {
          country: "",
          businessGroup: "",
          specialPack:"Including",
          launchPack:["All"],
          TargetDensity: "Top Performers (Country)",
          riskFactor2Y: 25,
          riskSavingfactor: 25,
          primaryRisk: 75,
          palletRisk: 25,
          maxPalletWeight_single: 2205.0,
          maxPalletWeight_double: 2205.0,
          maxPFSpertruckPrimary: 30,
          maxPFSpertruckSecondary: 30,
          maxWeightpertruckPrimary: 45000,
          maxWeightpertruckSecondary: 45000,
          // Added by Kartick on 9th May for Indonesia market
          oneYSuDCSavings: 75,
          emptyPalletWeight: 55,
          maxPalletWeight: 1322,
          storageSavings: 25,
          twoSavings: 25,
          palletMgtService: 25,
          oneYInterDCSavings: 25,
          handlingInSavings: 75,
          handingOutSavings: 75,
          oneyMaxCapacityPerTruck: 44092.45,
          oneyMaxPFSPerTruck: 16,
        },
        internalFilter: {
          country: "",
          businessGroup: "",
          Category: "",
          format: "",
          brand:"",
          PackType: "",
          specialPack:"",
          launchPack:"",
          savings: 4000,
        },
        densityLoss: [],
        error: {},
        heightFilter: {
          country: "",
          businessGroup: "",
          category: "",
          brand: "",
          format: "",
          sizePackForm: "",
          specialPack: "",
          launchPack:""
        },
      }

  
    default:
      return state
  }  
}

export default InterventionDetails
